/**
 * @generated SignedSource<<11d18e7e368bab9a1845fbe1c7c3b712>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LinkRelationshipTypeCell_issueRef$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef">;
  readonly " $fragmentType": "LinkRelationshipTypeCell_issueRef";
};
export type LinkRelationshipTypeCell_issueRef$key = {
  readonly " $data"?: LinkRelationshipTypeCell_issueRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"LinkRelationshipTypeCell_issueRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "LinkRelationshipTypeCell_issueRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_IssueFieldLinkRelationshipInlineEditFull_LinkRelationshipInlineEditView_issueRef"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "24d8dd2e4859e1fdbaadfd853328b22a";

export default node;
